import { SettingOutlined } from "@ant-design/icons";
import { Button, Space, Tooltip } from "../ui";

export interface DashboardConfigurationLabels { configure: string; cancel: string; save: string }
export function DashboardConfigurationActions({ editing, saving, disabled, onBegin, onCancel, onSave, labels }: {
  editing: boolean; saving: boolean; disabled?: boolean; onBegin: () => void; onCancel: () => void; onSave: () => void; labels: DashboardConfigurationLabels;
}) {
  return editing ? <Space>
    <Button disabled={saving} onClick={onCancel}>{labels.cancel}</Button>
    <Button type="primary" loading={saving} onClick={onSave}>{labels.save}</Button>
  </Space> : <Tooltip title={labels.configure}>
    <Button type="text" disabled={disabled} icon={<SettingOutlined />} aria-label={labels.configure} onClick={onBegin} />
  </Tooltip>;
}
